import PropTypes from "prop-types"
import styled from "styled-components"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`

export const SelectButton = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  border: 1px solid #cccccc;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 18px;
  font-weight: 300;
  margin: ${(props) => (props.margin ? props.margin : "0 30px 0 30px;")};
  opacity: ${(props) => (props.loading ? 0.5 : 1)};
  padding: 15px;
  text-align: center;
  transition: background-color 300ms ease-in;
  &:disabled {
    background-color: #a0a0a0;
    color: "#FFFFFF";
  }
`

// Replace with plain Button component
export const StyledButton = styled(Button)`
  border-radius: 5px;
  font-size: 18px;
  font-weight: 500;
  height: 48px;
  line-height: 16px;
  padding: 0;
  &:disabled {
    background: ${(props) => props.theme.colors.grey[35]};
  }
`

export const ButtonLink = styled.div`
  border-radius: 5pt;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  margin: ${(props) => (props.noMargin ? "none;" : "0 30px 0 30px;")};
  padding: 15px;
  text-align: center;
`

// export const ButtonWrapper = styled(Flex).attrs((props) => ({
//   flexDirection: "column",
//   gap: "10px",
//   mb: { _: 1, tablet: "12px" },
//   mt: { _: 2, tablet: "22px" },
//   mx: { tablet: "auto" },
//   pl: { _: 1, tablet: 0 },
//   pr: { _: 1, tablet: 0 },
//   width: { _: "100%", tablet: "260px" },
//   ...props,
// }))``

export const ButtonWrapper = ({ className, ...props }) => (
  <div
    className={cn(
      "tablet:mb-12 tablet:mt-22 tablet:mx-auto tablet:pl-0 tablet:pr-0 tablet:w-260 mb-8 mt-16 flex w-full flex-col gap-16 pl-8 pr-8",
      className
    )}
    {...props}
  />
)

ButtonWrapper.propTypes = {
  className: PropTypes.string,
}
